"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tiny_lru_1 = require("tiny-lru");
// eslint-disable-next-line unicorn/prefer-node-protocol
const url_1 = require("url");
const Route_1 = require("./Route");
/**
 * A collection of routes for use in a NextJs application.
 *
 * @author Adam Ayres
 */
class Routes {
    constructor(basePath = null) {
        this.routes = {};
        this.routePages = {};
        this.pathCache = (0, tiny_lru_1.lru)(1000, 1000 * 60 * 60 * 24);
        this.basePath = basePath ? `/${basePath}` : '';
    }
    add(name, urlPath, page) {
        if (this.getRouteByName(name)) {
            throw new Error(`Route "${name}" already exists`);
        }
        const pattern = `${this.basePath}${urlPath}`;
        Object.assign(this.routes, {
            [name]: new Route_1.Route(name, pattern, page)
        });
        const pageKey = page.slice(page.lastIndexOf('/') + 1);
        Object.assign(this.routePages, { [pageKey]: name });
        return this;
    }
    getRouteByName(routeName) {
        if (routeName) {
            return this.routes[routeName];
        }
        return undefined;
    }
    getRouteByPath(path) {
        var _a;
        return (_a = this.getRouteAndParamsByPath(path)) === null || _a === void 0 ? void 0 : _a.route;
    }
    getRouteAndParamsByPath(path) {
        const cachedResult = this.pathCache.get(path);
        if (cachedResult) {
            const cachedRoute = this.routes[cachedResult.name];
            if (cachedRoute) {
                return {
                    route: cachedRoute,
                    params: Object.assign({}, cachedResult.params),
                    query: Object.assign({}, cachedResult.query)
                };
            }
        }
        const { pathname, query } = (0, url_1.parse)(path, true);
        let route = null;
        let params = {};
        if (pathname) {
            for (const currentRoute of Object.values(this.routes)) {
                const match = currentRoute.match(pathname);
                if (match !== false) {
                    ({ params } = match);
                    route = currentRoute;
                    this.pathCache.set(path, {
                        name: route.name,
                        query: query,
                        params
                    });
                    break;
                }
            }
        }
        return {
            route,
            params: Object.assign({}, params),
            query: Object.assign({}, query)
        };
    }
    getRouteNameByPage(page) {
        return this.routePages[page];
    }
    findAndGetUrls(routeName, parameters = {}, queryParams) {
        const route = this.getRouteByName(routeName);
        if (route) {
            return {
                internalRelativeUrl: route.getInternalRelativeUrl(parameters, queryParams),
                externalRelativeUrl: route.getRelativeUrl(parameters, queryParams)
            };
        }
        return {
            internalRelativeUrl: routeName === null || routeName === void 0 ? void 0 : routeName.toString(),
            externalRelativeUrl: routeName === null || routeName === void 0 ? void 0 : routeName.toString()
        };
    }
}
exports.default = Routes;
//# sourceMappingURL=Routes.js.map